export default __webpack_public_path__ + "864a2e3ea073b790d8ae8fc874f7580f.png";